//const KayanURL = "http://localhost:4000/";
const KayanURL = "https://ksa.kayan-healthcare.com/";

let settings = {
  KayanURL,
};
export default settings;
